"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _sha = _interopRequireDefault(require("crypto-js/sha256"));
var _encBase = _interopRequireDefault(require("crypto-js/enc-base64"));
var _Unauthenticated = _interopRequireDefault(require("./errors/Unauthenticated"));
var _UnknownLoginType = _interopRequireDefault(require("./errors/UnknownLoginType"));
var _oauthApi = _interopRequireDefault(require("./oauthApi"));
var _types = require("./types");
var _JwtModel = _interopRequireDefault(require("./JwtModel"));
// import moment from 'moment';

var codeExIsInProg = false;
var storage = window.localStorage;
var SessionHandler = /*#__PURE__*/function () {
  function SessionHandler() {
    (0, _classCallCheck2.default)(this, SessionHandler);
  }
  return (0, _createClass2.default)(SessionHandler, null, [{
    key: "setConfig",
    value: function setConfig(givenConfig, xhrConnector) {
      SessionHandler.config = givenConfig;
      _oauthApi.default.setup(givenConfig, xhrConnector);
    }
  }, {
    key: "getConfig",
    value: function getConfig() {
      return SessionHandler.config;
    }
  }, {
    key: "setStorage",
    value: function setStorage(newStorage) {
      storage = newStorage;
    }

    /**
     * 
     * @param token you can pass an object {accessToken, refreshToken}, otherwise use string and it will be saved a normal token
     * @param loginType the logintype which should be used
     * @param tokenType 
     */
  }, {
    key: "initSession",
    value: function initSession(token, loginType, tokenType) {
      if (!Object.values(_types.loginTypes).includes(loginType)) {
        throw new _UnknownLoginType.default(SessionHandler.UnkonwnLoginTypeMsg, loginType);
      }
      if (token && typeof token === "string") {
        SessionHandler.setToken(token, tokenType);
      } else if (typeof token !== "string") {
        SessionHandler.setRefreshToken(token.refreshToken);
        SessionHandler.setToken(token.accessToken, tokenType);
      }
      SessionHandler.setLoginType(loginType);
    }
  }, {
    key: "getLoginType",
    value: function getLoginType() {
      return storage.loginType;
    }
  }, {
    key: "setLoginType",
    value: function setLoginType(type) {
      storage.loginType = type;
    }
  }, {
    key: "destroySsoLoginPageSession",
    value: function destroySsoLoginPageSession() {
      location.replace(SessionHandler.config.loginPageExitUrl);
    }
  }, {
    key: "generateCiamLoginUrl",
    value: function generateCiamLoginUrl() {
      SessionHandler.setCurrentCodeVerifier(SessionHandler.generateCodeVerifier());
      var codeVerifier = SessionHandler.getCurrentCodeVerifier();
      var codeChallange = "&code_challenge=".concat(SessionHandler.generateCodeChallenge(codeVerifier), "&code_challenge_method=S256");
      return "".concat(SessionHandler.config.loginPageUrl, "&client_id=").concat(encodeURIComponent(SessionHandler.config.clientId), "&redirect_uri=").concat(encodeURIComponent(SessionHandler.config.loginSuccessPath)).concat(codeChallange, "}");
    }
  }, {
    key: "setCurrentCodeVerifier",
    value: function setCurrentCodeVerifier(code) {
      sessionStorage.setItem('code_verifier', code);
    }
  }, {
    key: "getConfigFromDomByName",
    value: function getConfigFromDomByName(name) {
      var decodeEntities = function decodeEntities(givenStr) {
        var str = givenStr;
        // this prevents any overhead from creating the object each time
        var element = document.createElement('div');
        if (str && typeof str === 'string') {
          // strip script/html tags
          str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gim, '');
          str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gim, '');
          element.innerHTML = str;
          str = element.textContent ? element.textContent : '';
          element.textContent = '';
        }
        return str;
      };
      var getIdDataset = function getIdDataset(dataSetName) {
        var elem = document.getElementById(name);
        if (elem && elem.dataset) {
          return elem.dataset[dataSetName];
        }
        return null;
      };
      var data = getIdDataset('props');
      return data ? JSON.parse(decodeEntities(data)) : null;
    }
  }, {
    key: "getCurrentCodeVerifier",
    value: function getCurrentCodeVerifier() {
      return sessionStorage.getItem('code_verifier') || '';
    }
  }, {
    key: "removeCodeVerifier",
    value: function removeCodeVerifier() {
      sessionStorage.removeItem('code_verifier');
    }
  }, {
    key: "parseJwt",
    value: function parseJwt(token) {
      if (!token) {
        return null;
      }
      var base64Url = token.split('.')[1];
      var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return "%".concat("00".concat(c.charCodeAt(0).toString(16)).slice(-2));
      }).join(''));
      return JSON.parse(jsonPayload);
    }
  }, {
    key: "destroyLocalSession",
    value: function destroyLocalSession() {
      delete storage.loginType;
      delete storage.refreshToken;
      delete storage.ciamtoken;
      delete storage.cscntoken;
    }
  }, {
    key: "setLogoutSuccessPage",
    value: function setLogoutSuccessPage(logoutLandingUrl) {
      storage.logoutSuccessPage = logoutLandingUrl;
    }
  }, {
    key: "getLogoutSuccessPage",
    value: function getLogoutSuccessPage() {
      return storage.logoutSuccessPage;
    }

    /**
     * 
     * @param logoutLandingUrl 
     * @param customRedirect if custom redirection is set, the remote CIAM url won't be called
     */
  }, {
    key: "destroySession",
    value: function destroySession() {
      var logoutLandingUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var customRedirect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      SessionHandler.destroyLocalSession();
      if (!customRedirect) {
        SessionHandler.setLogoutSuccessPage(logoutLandingUrl);
        SessionHandler.destroySsoLoginPageSession();
      } else {
        location.replace(logoutLandingUrl);
      }
    }
  }, {
    key: "getCodeFromUrl",
    value: function getCodeFromUrl() {
      var urlSearchParams = new URLSearchParams(window.location.search);
      return urlSearchParams.get('code') || '';
    }
  }, {
    key: "isValidCiamLogin",
    value: function isValidCiamLogin() {
      return !!SessionHandler.getCodeFromUrl();
    }

    /**
     * 
     * @param loginType specifify which logintype is related to the ciam token exchange
     * @returns 
     */
  }, {
    key: "initCiamAuthorizationExchange",
    value: function initCiamAuthorizationExchange(loginType) {
      if (codeExIsInProg) {
        return Promise.resolve();
      }
      var returnPromise = new Promise(function (resolve, reject) {
        if (!SessionHandler.isValidCiamLogin()) {
          reject();
        }
        var authResult = _oauthApi.default.authorizationCodeExchange(SessionHandler.getCodeFromUrl(), SessionHandler.getCurrentCodeVerifier());
        authResult.then(function (response) {
          codeExIsInProg = true;
          SessionHandler.removeCodeVerifier();
          if (response.data && response.data.id_token) {
            SessionHandler.initSession({
              accessToken: response.data.id_token,
              refreshToken: response.data.refresh_token
            }, loginType, _types.tokenTypes.ciam);
          } else {
            reject();
          }
          resolve(response);
        });
        authResult.catch(function () {
          reject();
        });
      });
      return returnPromise;
    }

    /**
     * 
     * @param types you can pass multiple logintypes e.g. userMustBeLoggedIn(logintype1, logintype2)
     */
  }, {
    key: "userMustBeLoggedIn",
    value: function userMustBeLoggedIn() {
      for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
        types[_key] = arguments[_key];
      }
      types.forEach(function (type) {
        if (!Object.values(_types.loginTypes).includes(type)) {
          throw new _UnknownLoginType.default(SessionHandler.UnkonwnLoginTypeMsg, type);
        }
      });
      if (!SessionHandler.isUserLoggedIn.apply(SessionHandler, types)) {
        var newExp = new _Unauthenticated.default('Not logged in');
        newExp.loginType = types;
        throw newExp;
      }
    }
  }, {
    key: "isUserLoggedIn",
    value: function isUserLoggedIn() {
      for (var _len2 = arguments.length, types = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        types[_key2] = arguments[_key2];
      }
      types.forEach(function (type) {
        if (!Object.values(_types.loginTypes).includes(type)) {
          throw new _UnknownLoginType.default(SessionHandler.UnkonwnLoginTypeMsg, type);
        }
      });
      return storage && types.includes(SessionHandler.getLoginType());
    }
  }, {
    key: "getToken",
    value: function getToken(type) {
      return storage && storage["".concat(type, "token")];
    }
  }, {
    key: "getRefreshToken",
    value: function getRefreshToken() {
      var _storage;
      return (_storage = storage) === null || _storage === void 0 ? void 0 : _storage.refreshToken;
    }
  }, {
    key: "setToken",
    value: function setToken(value, type) {
      storage["".concat(type, "token")] = value;
    }
  }, {
    key: "setRefreshToken",
    value: function setRefreshToken(value) {
      storage.refreshToken = value;
    }
  }, {
    key: "generateCodeChallenge",
    value: function generateCodeChallenge(codeVerifier) {
      return SessionHandler.base64URL((0, _sha.default)(codeVerifier));
    }
  }, {
    key: "base64URL",
    value: function base64URL(string) {
      return string.toString(_encBase.default).replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    }
  }, {
    key: "generateCodeVerifier",
    value: function generateCodeVerifier() {
      var array = new Uint32Array(56 / 2);
      window.crypto.getRandomValues(array);
      // Converts it from dec to hex
      return Array.from(array, function (dec) {
        return "0".concat(dec.toString(16)).substr(-2);
      }).join('');
    }
  }, {
    key: "isUserAssignedToApp",
    value: function isUserAssignedToApp(appName) {
      return _JwtModel.default.isUserAssignedToApp(appName, SessionHandler.getToken(_types.tokenTypes.ciam));
    }
  }, {
    key: "isUserAssignedToScope",
    value: function isUserAssignedToScope(scopeId) {
      return _JwtModel.default.isUserAssignedToScope(scopeId, SessionHandler.getToken(_types.tokenTypes.ciam));
    }
  }]);
}();
(0, _defineProperty2.default)(SessionHandler, "config", void 0);
(0, _defineProperty2.default)(SessionHandler, "UnkonwnLoginTypeMsg", 'Proper login type is not specified!');
var _default = exports.default = SessionHandler;